import SahamLoader from 'containers/AppContainer/Loader/index';
import { get } from 'lodash';
export default (WrappedComponent: any, loaderType: any) => {
  return function(props: any) {
    const isLoading = Object.entries(props.loaders).some(([key, value]) => {
      const condition = loaderType.map((item: string) => {
        return item === key && value;
      });
      return condition.every((el: any) => !el) ? false : true;
    });
    return (
      <div>
        {isLoading ? (
          <SahamLoader
            withOpacity={
              get(props.loaders, 'NOTIFICATION_INBOXES', false) ||
              get(props.loaders, 'TRACKING_USER', false)
            }
          />
        ) : (
          <WrappedComponent {...props} />
        )}
      </div>
    );
  };
};
